import { useEffect } from "react";

export const useChangeFromContextMenu = (ref, pushChange,  opened, calendar) => {
  useEffect(() => {
    if (!opened || calendar) {
      return
    }

    const handleClick = (e) => {
      if (!ref.current || ref.current.contains(e.target)) {
        return
      }
      else {
        pushChange()
      }
    }

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    }

  }, [ref, opened, pushChange, calendar])

}